class MarginCalculatorPresenter {
    constructor(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
        this.strategyList = [];
    }
    calculateMargin(req) {
        this.actions.calculateMargin.startLoader();
        this.usecase.calculateMargin.execute({
            onSuccess: (data) => {
                this.actions.calculateMargin.getCalculatedMargin(data);
            },
            onError: (error) => {
                this.actions.calculateMargin.setError({ isOpen: true, error });
                this.actions.calculateMargin.stopLoader();
            },
        }, req);
    }
    getSearchSymbol(req) {
        return new Promise((resolve, reject) => {
            this.usecase.getSearchedSymbolData.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    getDerivativeDetails(req) {
        return new Promise((resolve, reject) => {
            this.usecase.getDerivativeDetails.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    getStrikePriceList(req) {
        return new Promise((resolve, reject) => {
            this.usecase.getStrikePriceList.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    getExpiryDate() {
        return new Promise((resolve, reject) => {
            this.usecase.getExpirydate.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, null);
        });
    }
    getStrategyList() {
        return this.strategyList;
    }
    editStrategy(data) {
        this.strategyList = data;
    }
    addStrategy(data) {
        this.strategyList.push(data);
    }
    deleteStrategy(index) {
        this.strategyList.splice(index, 1);
    }
    clearAllStrategy() {
        this.strategyList = [];
    }
}
export default MarginCalculatorPresenter;
